import { render, staticRenderFns } from "./IotDevicePortCreateDialog.vue?vue&type=template&id=475a0c4c&scoped=true"
import script from "./IotDevicePortCreateDialog.vue?vue&type=script&lang=ts"
export * from "./IotDevicePortCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a0c4c",
  null
  
)

export default component.exports